import guideStep1Desktop from './guide-step-1-desktop.png';
import guideStep2Desktop from './guide-step-2-desktop.png';
import guideStep3Desktop from './guide-step-3-desktop.png';
import guideStep4Desktop from './guide-step-4-desktop.png';
import guideStep5Desktop from './guide-step-5-desktop.png';
import guideStep6Desktop from './guide-step-6-desktop.png';
import guideStep7Desktop from './guide-step-7-desktop.png';
import guideStep8Desktop from './guide-step-8-desktop.png';
import guideStep9Desktop from './guide-step-9-desktop.png';

import guideStep1Mobile from './guide-step-1-mobile.png';
import guideStep2Mobile from './guide-step-2-mobile.png';
import guideStep3Mobile from './guide-step-3-mobile.png';
import guideStep4Mobile from './guide-step-4-mobile.png';
import guideStep5Mobile from './guide-step-5-mobile.png';
import guideStep6Mobile from './guide-step-6-mobile.png';
import guideStep7Mobile from './guide-step-7-mobile.png';
import guideStep8Mobile from './guide-step-8-mobile.png';
import guideStep9Mobile from './guide-step-9-mobile.png';
import guideStep10Mobile from './guide-step-10-mobile.png';

export const GUIDE_STEPS_DESKTOP = [
  guideStep1Desktop,
  guideStep2Desktop,
  guideStep3Desktop,
  guideStep4Desktop,
  guideStep5Desktop,
  guideStep6Desktop,
  guideStep7Desktop,
  guideStep8Desktop,
  guideStep9Desktop,
];

export const GUIDE_STEPS_MOBILE = [
  guideStep1Mobile,
  guideStep2Mobile,
  guideStep3Mobile,
  guideStep4Mobile,
  guideStep5Mobile,
  guideStep6Mobile,
  guideStep7Mobile,
  guideStep8Mobile,
  guideStep9Mobile,
  guideStep10Mobile,
];
